import { useQuery } from '@tanstack/react-query';
import parseHtmlToReact from 'html-react-parser';
import type { ReactNode } from 'react';
import { memo, useEffect, useRef } from 'react';

import { withErrorBoundary } from '../ErrorBoundary';
import { getLibraryContentQuery } from '../queries/common';

import pluginLoaderInstance from '@core/plugin-loader';

const SlotIncluder = ({
  className,
  path,
  placeholder,
}: {
  className?: string;
  path: string;
  placeholder?: ReactNode;
}) => {
  const container = useRef<HTMLDivElement>(null);

  const { data: content, isFetched, isLoading } = useQuery(getLibraryContentQuery<string>(path, 'text'));

  useEffect(() => {
    if (!isFetched || isLoading) return;

    const currentContainer = container.current;
    currentContainer && pluginLoaderInstance.detach(currentContainer);

    return () => {
      currentContainer && pluginLoaderInstance.detach(currentContainer);
    };
  }, [isFetched, isLoading]);

  if (placeholder && isLoading) return <>{placeholder}</>;

  if (!content) return null;

  return (
    <div ref={container} className={className}>
      {parseHtmlToReact(content ?? '')}
    </div>
  );
};

export default withErrorBoundary(memo(SlotIncluder));
